import type WebSocket from 'ws';
import type { CliE2eeRuntime } from '../lib/e2ee/index.js';
import type { LogFn } from '../log.js';
import type { BridgeIdentifyReportedPaths } from './bridge-connection-runtime-types.js';
import { createBridgeHeartbeatController, type BridgeHeartbeatController } from './heartbeat/controller.js';
import {
  BRIDGE_IDENTIFY_REFRESH_EVERY_TICKS,
  sendBridgeIdentify,
} from './send-bridge-identify.js';

export function createBridgeIdentifyHeartbeat(params: {
  getWs: () => WebSocket | null;
  log: LogFn;
  identifyReportedPaths: BridgeIdentifyReportedPaths;
  e2ee: CliE2eeRuntime | undefined;
}): BridgeHeartbeatController {
  const { getWs, log, identifyReportedPaths, e2ee } = params;
  return createBridgeHeartbeatController({
    getWs,
    log,
    onEveryNTicks: {
      n: BRIDGE_IDENTIFY_REFRESH_EVERY_TICKS,
      fn: () => sendBridgeIdentify(getWs(), { identifyReportedPaths, e2ee }),
    },
  });
}
